import {FC, ReactNode, RefObject} from "react";
import {IoAddCircleOutline} from "react-icons/io5";
import {BaseConfiguratorModal} from "./shared";

type Props = {
    open: boolean;
    onClose: () => void;
    children?: ReactNode;
    title: string;
    confirmText: string;
    onConfirm: () => void;
    contentRef?: RefObject<HTMLDivElement>;
};

export const EventConfigurationModal: FC<Props> = ({open, onClose, children, title, onConfirm, confirmText, contentRef}) => {

    return (
        <BaseConfiguratorModal
            open={open}
            onClose={onClose}
            title={title}
            contentRef={contentRef}
            footer={
                <>
                    <button
                        type="button"
                        onClick={onConfirm}
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                    >
                        <IoAddCircleOutline/>
                        {confirmText}
                    </button>
                    <button
                        className="px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
                        onClick={onClose}
                    >
                        Zavřít
                    </button>
                </>
            }
        >
            {children}
        </BaseConfiguratorModal>
    );
};